import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { bookingRootRoute } from '@booking/booking-routing.module';
import { homeItemDetailRootRoute } from '@home-item-detail/home-item-detail-routing.module';
import { userHistoryRoute } from '@user-history/constants/history-routes.constants';
import { ModuleCountryGuard } from '@app/services/guard/module-country.guard';
import { userAlertsRoute } from '@user-alerts/constants/user-alerts-routes.constants';
import { USER_ALERTS } from '@app/constants/route-titles.constants';
import { autosRoutes } from '@app/routes/autos';
import { packagesAllModuleRoutes } from '@app/routes/packages';
import { flightsAllModuleRoutes } from '@app/routes/flights';
import { hotelsAllModuleRoutes } from '@app/routes/hotels';
import { busesAllModuleRoutes } from '@app/routes/buses';
import { policiesAndTermsRoutes } from '@app/routes/policies-and-terms';
import { bookingAndPaymentRoutes } from '@app/routes/booking-payment';
import { seatMapRootRoute } from '@seat-map/seat-map-routing.module';
import { HeaderPageType } from '@header/entities/ds-header-config';
import { HeaderType } from '@design-system/components/templates/header/entities/header.types';
import { RoutingLevel } from '@ux/animations/animations';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { activitiesAllModuleRoutes } from '@app/routes/tour-and-activities';

const routes: Routes = [
  {
    path: '', loadChildren: () =>
      import('./modules/home/home.module').then(m => m.HomeModule),
    data: {
      routingLevel: RoutingLevel.One,
      dsHeaderConfig: {
        type: HeaderType.FloatingRG,
        animatedType: HeaderType.FloatingSM,
        titleKey: null,
        pageType: HeaderPageType.HomePage,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
  {
    path: homeItemDetailRootRoute, loadChildren: () =>
      import('./modules/home-item-detail/home-item-detail.module').then(m => m.HomeItemDetailModule),
    data: {
      routingLevel: RoutingLevel.Two,
      dsHeaderConfig: {
        type: HeaderType.FloatingRG,
        animatedType: HeaderType.Generic,
        titleKey: null,
        pageType: HeaderPageType.LandingPage,
      },
    }
  },
  {
    path: userHistoryRoute, loadChildren: () =>
      import('./modules/user-history/user-history.module').then(m => m.UserHistoryModule),
  },
  {
    path: userAlertsRoute, loadChildren: () =>
      import('./modules/user-alerts/user-alerts.module').then(m => m.UserAlertsModule),
    data: {
      routingLevel: RoutingLevel.Three,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: USER_ALERTS,
        pageType: HeaderPageType.PriceAlertPage,
        titleIcon: Icon.Notification
      },
    }
  },
  {
    path: bookingRootRoute, loadChildren: () =>
      import('./modules/booking/booking.module').then(m => m.BookingModule),
    data: {
      routingLevel: RoutingLevel.Eight,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: null,
        pageType: HeaderPageType.BookingPage,
      },
    },
  },
  {
    path: 'icons', loadChildren: () =>
      import('./modules/page-icons/page-icons.module').then(m => m.PageIconsModule),
    data: {
      routingLevel: RoutingLevel.Two,
      dsHeaderConfig: {
        type: HeaderType.FloatingRG,
        titleKey: null,
        pageType: HeaderPageType.InfoPage,
      },
    }
  },
  ...flightsAllModuleRoutes,
  ...hotelsAllModuleRoutes,
  ...busesAllModuleRoutes,
  ...autosRoutes,
  ...packagesAllModuleRoutes,
  ...policiesAndTermsRoutes,
  ...bookingAndPaymentRoutes,
  ...activitiesAllModuleRoutes,
  {
    path: 'promo', loadChildren: () =>
      import('./modules/promotion-pages/promotion-pages.module').then(m => m.PromotionPagesModule),
    data: {
      routingLevel: RoutingLevel.Nine,
      dsHeaderConfig: {
        type: HeaderType.FloatingRG,
        titleKey: null,
        pageType: HeaderPageType.InfoPage,
      },
    }
  },
  {
    path: seatMapRootRoute, loadChildren: () =>
      import('./modules/seat-map/seat-map.module').then(m => m.SeatMapModule),
    data: {
      routingLevel: RoutingLevel.Five,
      dsHeaderConfig: {
        type: HeaderType.FloatingRG,
        titleKey: null,
        pageType: HeaderPageType.SeatMapPage,
      },
    },
    canActivate: [ModuleCountryGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
